export default "__VITE_ASSET__BpKLXvVK__"